import { ProductRecommendationEntity } from '@product/const/v2';
import { StateUtils } from '@spartacus/core';
import { PRODUCT_RECOMMENDATION_ENTITY } from '../product-recommendations-state';

export const LOAD_PRODUCT_RECOMMENDATION = '[Product-recommendation] Product-recommendation Load';
export const LOAD_PRODUCT_RECOMMENDATION_FAIL = '[Product-recommendation] Product-recommendation Load Fail';
export const LOAD_PRODUCT_RECOMMENDATION_SUCCESS = '[Product-recommendation] Product-recommendation Load Success';

export class ProductRecommendationLoad extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_PRODUCT_RECOMMENDATION;

  constructor(public payload: string) {
    super(PRODUCT_RECOMMENDATION_ENTITY);
  }
}

export class ProductRecommendationLoadFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_PRODUCT_RECOMMENDATION_FAIL;

  constructor(public payload: any) {
    super(PRODUCT_RECOMMENDATION_ENTITY, payload);
  }
}

export class ProductRecommendationLoadSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_PRODUCT_RECOMMENDATION_SUCCESS;

  constructor(public payload: ProductRecommendationEntity[] | null) {
    super(PRODUCT_RECOMMENDATION_ENTITY);
  }
}

export type ProductRecommendationLoadAction =
  | ProductRecommendationLoad
  | ProductRecommendationLoadFail
  | ProductRecommendationLoadSuccess;
